function FileBookshelfRepository() { }
FileBookshelfRepository.prototype.getHeaderMenuVisibility = async () => {
  return false;
};

FileBookshelfRepository.prototype.isShowBookStoreComponent = () => {
  return false;
};

export default new FileBookshelfRepository();